import { createReducer } from '@reduxjs/toolkit';

import { GlobalState } from '../../../types.global';
import { INewsState } from './types';

import { fetchNews } from './thunks';

export const getInitialNewsState = (state: GlobalState): INewsState => {
  const { news } = state;

  return {
    data: null,
    lastFetched: null,
    isMinimized: false,
    ...news,
  };
};

const reducer = createReducer(null, (builder) => {
  builder.addCase(fetchNews.fulfilled, (state: INewsState, { payload }) => {
    if (payload) {
      state.data = payload;
      state.lastFetched = Date.now();
    }
  });
});

export default reducer;
